import type { Sport } from '../types';

export const sports: Sport[] = [
  { id: 'running', name: '러닝', emoji: '🏃', category: '걷기·달리기', popular: true },
  { id: 'walking', name: '걷기', emoji: '🚶', category: '걷기·달리기', popular: true },
  { id: 'hiking', name: '등산', emoji: '⛰️', category: '걷기·달리기', popular: true },
  { id: 'trail-running', name: '트레일러닝', emoji: '🌲', category: '걷기·달리기' },
  { id: 'barefoot-walking', name: '맨발걷기', emoji: '🦶', category: '걷기·달리기' },
  { id: 'soccer', name: '축구', emoji: '⚽', category: '구기', popular: true },
  { id: 'futsal', name: '풋살', emoji: '🥅', category: '구기', popular: true },
  { id: 'basketball', name: '농구', emoji: '🏀', category: '구기', popular: true },
  { id: 'volleyball', name: '배구', emoji: '🏐', category: '구기' },
  { id: 'baseball', name: '야구', emoji: '⚾', category: '구기' },
  { id: 'softball', name: '소프트볼', emoji: '🥎', category: '구기' },
  { id: 'foot-volleyball', name: '족구', emoji: '🦵', category: '구기', popular: true },
  { id: 'dodgeball', name: '피구', emoji: '🔴', category: '구기' },
  { id: 'tennis', name: '테니스', emoji: '🎾', category: '라켓', popular: true },
  { id: 'badminton', name: '배드민턴', emoji: '🏸', category: '라켓', popular: true },
  { id: 'table-tennis', name: '탁구', emoji: '🏓', category: '라켓', popular: true },
  { id: 'squash', name: '스쿼시', emoji: '🟡', category: '라켓' },
  { id: 'pickleball', name: '피클볼', emoji: '🥒', category: '라켓' },
  { id: 'padel', name: '파델', emoji: '🎾', category: '라켓' },
  { id: 'golf', name: '골프', emoji: '⛳', category: '골프', popular: true },
  { id: 'screen-golf', name: '스크린골프', emoji: '🏌️', category: '골프', popular: true },
  { id: 'park-golf', name: '파크골프', emoji: '🌳', category: '골프', popular: true },
  { id: 'billiards', name: '당구', emoji: '🎱', category: '실내', popular: true },
  { id: 'bowling', name: '볼링', emoji: '🎳', category: '실내', popular: true },
  { id: 'climbing', name: '클라이밍', emoji: '🧗', category: '실내', popular: true },
  { id: 'darts', name: '다트', emoji: '🎯', category: '실내' },
  { id: 'cycling', name: '자전거', emoji: '🚴', category: '아웃도어', popular: true },
  { id: 'mtb', name: '산악자전거', emoji: '🚵', category: '아웃도어' },
  { id: 'swimming', name: '수영', emoji: '🏊', category: '수상', popular: true },
  { id: 'surfing', name: '서핑', emoji: '🏄', category: '수상' },
  { id: 'scuba', name: '스쿠버다이빙', emoji: '🤿', category: '수상' },
  { id: 'kayak', name: '카약·SUP', emoji: '🛶', category: '수상' },
  { id: 'yoga', name: '요가', emoji: '🧘', category: '건강·피트니스', popular: true },
  { id: 'pilates', name: '필라테스', emoji: '🤸', category: '건강·피트니스', popular: true },
  { id: 'gym', name: '헬스', emoji: '🏋️', category: '건강·피트니스', popular: true },
  { id: 'crossfit', name: '크로스핏', emoji: '💪', category: '건강·피트니스', popular: true },
  { id: 'calisthenics', name: '맨몸운동', emoji: '🤸', category: '건강·피트니스' },
  { id: 'dance', name: '댄스', emoji: '💃', category: '댄스·리듬', popular: true },
  { id: 'zumba', name: '줌바', emoji: '🎶', category: '댄스·리듬' },
  { id: 'kendo', name: '검도', emoji: '🥋', category: '무도·격투' },
  { id: 'taekwondo', name: '태권도', emoji: '🥋', category: '무도·격투' },
  { id: 'boxing', name: '복싱', emoji: '🥊', category: '무도·격투', popular: true },
  { id: 'kickboxing', name: '킥복싱', emoji: '🥊', category: '무도·격투' },
  { id: 'jiujitsu', name: '주짓수', emoji: '🥋', category: '무도·격투' },
  { id: 'ski', name: '스키', emoji: '⛷️', category: '계절' },
  { id: 'snowboard', name: '스노보드', emoji: '🏂', category: '계절' },
  { id: 'skating', name: '스케이트', emoji: '⛸️', category: '계절' },
  { id: 'rowing', name: '조정', emoji: '🚣', category: '기타' },
  { id: 'frisbee', name: '얼티미트·프리스비', emoji: '🥏', category: '기타' },
  { id: 'gateball', name: '게이트볼', emoji: '🏑', category: '기타' },
  { id: 'archery', name: '양궁', emoji: '🏹', category: '기타' }
];

export const sportMap = new Map(sports.map((sport) => [sport.id, sport]));
export const categories = Array.from(new Set(sports.map((sport) => sport.category)));
